/* lessentialss — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll: un único observer compartido */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, .mt-mask, .mt-img-reveal, .mt-steps__line, [data-mt-reveal]');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { if (!el.classList.contains('mt-visible')) io.observe(el); });
  }

  /* Parallax suave (solo transform) */
  function initParallax() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-mt-parallax]'));
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Carrusel de productos: flechas + barra de progreso */
  function initCarousels() {
    document.querySelectorAll('[data-mt-carousel]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var track = wrap.querySelector('.mt-prods__track');
      var bar = wrap.querySelector('.mt-progress span');
      if (!track) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; }
      var prev = wrap.querySelector('[data-prev]'), next = wrap.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      function prog() {
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth;
        var vis = track.clientWidth / track.scrollWidth;
        bar.style.width = (vis * 100) + '%';
        var p = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (1 / vis - 1) * 100) + '%)';
      }
      track.addEventListener('scroll', prog, { passive: true });
      window.addEventListener('resize', prog);
      prog();
    });
  }

  /* Producto estrella: los pasos de texto cambian el ángulo de la foto */
  function initStar() {
    document.querySelectorAll('[data-mt-star]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var imgs = sec.querySelectorAll('.mt-star__stack img');
      var dots = sec.querySelectorAll('.mt-star__dots span');
      var steps = sec.querySelectorAll('[data-star-step]');
      function show(i) {
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      if (!('IntersectionObserver' in window)) { show(0); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            steps.forEach(function (s) { s.classList.remove('is-active'); });
            e.target.classList.add('is-active');
            show(parseInt(e.target.getAttribute('data-star-step'), 10) % Math.max(imgs.length, 1));
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
      show(0);
    });
  }

  /* Acordeones (FAQ y página de producto) */
  function initAccordions() {
    document.querySelectorAll('[data-mt-acc]').forEach(function (btn) {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Página de producto: galería, variantes, cantidad, añadir al carrito */
  function initProduct() {
    document.querySelectorAll('[data-mt-pdp]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var main = root.querySelector('.mt-pdp__main');
      var mainImg = main && main.querySelector('img');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.mt-pdp__thumb'));
      var current = 0;

      function setImage(i) {
        if (!thumbs.length || !mainImg) return;
        current = (i + thumbs.length) % thumbs.length;
        var t = thumbs[current];
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        mainImg.classList.add('is-fading');
        setTimeout(function () {
          mainImg.src = t.getAttribute('data-full');
          mainImg.srcset = t.getAttribute('data-srcset') || '';
          mainImg.alt = t.getAttribute('data-alt') || '';
          mainImg.onload = function () { mainImg.classList.remove('is-fading'); };
          setTimeout(function () { mainImg.classList.remove('is-fading'); }, 400);
        }, 180);
        t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { setImage(i); }); });
      var prev = root.querySelector('[data-img-prev]'), next = root.querySelector('[data-img-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); setImage(current - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); setImage(current + 1); });

      /* Zoom al pasar el ratón */
      if (main && window.matchMedia('(hover: hover)').matches) {
        main.addEventListener('click', function () { main.classList.toggle('is-zoom'); });
        main.addEventListener('mousemove', function (e) {
          var r = main.getBoundingClientRect();
          main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
        main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
      }

      /* Variantes */
      var dataEl = root.querySelector('[data-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelectorAll('[data-price]');
      var priceWas = root.querySelector('[data-compare]');
      var save = root.querySelector('[data-save]');
      var addBtn = root.querySelector('.mt-pdp__add');
      var addLabel = addBtn ? addBtn.querySelector('[data-label]') : null;
      var txtAdd = root.getAttribute('data-txt-add');
      var txtSold = root.getAttribute('data-txt-sold');
      /* Muestra de formato en la moneda que ve el cliente (p. ej. "$1,234.56 USD"): se sustituye solo la cifra */
      var sample = root.getAttribute('data-money-sample') || '$1,234.56';

      function money(cents) {
        var parts = (cents / 100).toFixed(2).split('.');
        var num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        return sample.replace(/\d[\d.,]*\d/, num);
      }

      function selected() {
        var vals = [];
        root.querySelectorAll('.mt-opt').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
          var lab = fs.querySelector('legend span');
          if (lab && c) lab.textContent = c.value;
        });
        return vals;
      }

      function onChange() {
        var vals = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = root.getAttribute('data-txt-unavailable');
          return;
        }
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (p) { p.textContent = money(v.price); });
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = money(v.compare_at_price); priceWas.hidden = false;
            if (save) { save.hidden = false; save.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else { priceWas.hidden = true; if (save) save.hidden = true; }
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? txtAdd : txtSold;
        if (v.featured_media && thumbs.length) {
          var idx = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == v.featured_media.id; });
          if (idx > -1) setImage(idx);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('.mt-opt input').forEach(function (inp) { inp.addEventListener('change', onChange); });

      /* Cantidad */
      var qty = root.querySelector('.mt-qty input');
      root.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
          qty.value = n;
        });
      });

      /* Añadir al carrito con el cajón de Dawn (si existe); si no, envío normal */
      var form = root.querySelector('form[action*="/cart/add"]');
      var msg = root.querySelector('.mt-pdp__msg');
      if (form) form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        e.preventDefault();
        addBtn.classList.add('is-loading');
        var fd = new FormData(form);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
            if (msg) msg.textContent = '';
            drawer.classList.remove('is-empty');
            var inner = drawer.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });

      /* Barra de compra fija al bajar */
      var bar = document.querySelector('.mt-sticky-atc');
      if (bar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(addBtn);
        var sb = bar.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          if (addBtn.disabled) { root.scrollIntoView({ behavior: 'smooth' }); return; }
          addBtn.click();
        });
      }
    });
  }

  /* Menú de categorías: centra la píldora activa sin mover la página */
  function initCatNav() {
    document.querySelectorAll('.mt-catnav__track').forEach(function (t) {
      var a = t.querySelector('.is-active');
      if (a) t.scrollLeft = a.offsetLeft - (t.clientWidth - a.offsetWidth) / 2;
    });
  }

  /* Copiar código de descuento al tocarlo */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mt-copy]');
    if (!b) return;
    var code = b.getAttribute('data-mt-copy');
    var done = function () {
      b.classList.add('is-copied');
      var l = b.querySelector('[data-copy-label]');
      if (l) l.textContent = '¡Copiado!';
      setTimeout(function () { b.classList.remove('is-copied'); if (l) l.textContent = 'Toca para copiar'; }, 2200);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* Ventana de bienvenida: aparece una vez, recuerda si se cerró o si ya se suscribió */
  function initBienvenida() {
    var bv = document.querySelector('[data-mt-bv]');
    if (!bv || bv.dataset.ready) return;
    bv.dataset.ready = '1';
    var tab = document.querySelector('[data-mt-bv-open]');
    var KEY = 'mt_bv', DIAS = 3, last = null, mostrado = false;
    var get = function () { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
    var set = function (v) { try { localStorage.setItem(KEY, v); } catch (e) {} };

    function open() {
      if (!bv.hidden && bv.classList.contains('is-open')) return;
      mostrado = true;
      last = document.activeElement;
      bv.hidden = false;
      if (tab) tab.hidden = true;
      document.documentElement.classList.add('mt-bv-lock');
      // setTimeout y no requestAnimationFrame: rAF no corre en pestañas en segundo plano
      setTimeout(function () { bv.classList.add('is-open'); }, 30);
      var f = bv.querySelector('input[type=email], .mt-bv__code');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 350);
    }
    function close() {
      bv.classList.remove('is-open');
      document.documentElement.classList.remove('mt-bv-lock');
      setTimeout(function () { bv.hidden = true; }, 400);
      if (get() !== 'suscrito') { set(String(Date.now())); if (tab) tab.hidden = false; }
      if (last && last.focus) last.focus({ preventScroll: true });
    }

    bv.querySelectorAll('[data-mt-bv-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (tab) tab.addEventListener('click', open);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bv.hidden) close(); });
    if (window.Shopify && Shopify.designMode) return;

    if (bv.hasAttribute('data-ok')) { set('suscrito'); open(); return; }
    // Si hubo un error en el formulario, la página recarga: volver a mostrarla
    if (bv.querySelector('.mt-bv__err')) { open(); return; }
    var s = get();
    if (s === 'suscrito') return;
    if (s && Date.now() - Number(s) < DIAS * 864e5) { if (tab) tab.hidden = false; return; }

    var timer = setTimeout(open, (Number(bv.dataset.delay) || 8) * 1000);
    var armado = false;
    setTimeout(function () { armado = true; }, 3000);
    document.addEventListener('mouseout', function (e) {
      if (armado && !e.relatedTarget && e.clientY <= 0 && !mostrado) { clearTimeout(timer); open(); }
    });
  }

  function initAll(root) {
    initReveal(root); initCarousels(); initStar(); initAccordions(); initProduct(); initCatNav(); initBienvenida();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); initParallax(); });
  /* Editor de Shopify: re-inicializar al cargar/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
